import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/Dapta-Brandmark-RGB.png'


const _withScopeId = n => (_pushScopeId("data-v-4e5ca222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rotate",
  width: "70",
  height: "70"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref, provide, inject } from "vue";
import { useRouter } from 'vue-router'
import { useAuth0 } from '@auth0/auth0-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { loginWithRedirect, isAuthenticated, idTokenClaims, getAccessTokenSilently } = useAuth0();
const router = useRouter();
const isLoading = ref(true);
const accessToken = ref();
// const authAPIEndPoint = inject('auth_API_end_point');

// disable logging
var DEBUG = false;
if(!DEBUG){
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }
}

router.beforeEach(async (to, from) => {
  const { requiresAuth } = to.meta
  if (requiresAuth) {
    try {
      accessToken.value = await getAccessTokenSilently();
      // const permission = await fetch(authAPIEndPoint + "/get_user_subscriptions", {
      //   method: "GET",
      //   headers: {
      //     "Authorization": `Bearer ${accessToken.value}`
      //   }
      // }).then(
      //   (response) => {
      //     if (response.ok) {
      //       return response.json()
      //     } else {
      //       return { "status": "Forbidden" }
      //     }
      //   }
      // ).then((data) => {
      //   isLoading.value = false
      //   if (data["status"] === "Success") {
      //     console.log("User permissions verified.")
      //     return true
      //   } else {
      //     console.log("Access Forbidden.")
      //     return '/403'
      //   }
      // })
      return true
    } catch (e) {
      console.log("Permissions check failed.")
      isLoading.value = false
      return '/403'
    }

  } else { 
    return true
  }

})

router.beforeResolve(async to => {
  if (to.path == "/") {
    console.warn("redirect")
    router.push('/interface')
  }
})

const loginUser = async () => {
  if (isAuthenticated) {
    provide("userJWTToken", accessToken)
    console.log("User Authenticated.")
    } else {
      loginWithRedirect()
      provide("userJWTToken", accessToken)
    }
}
loginUser()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}
}

})